// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer-card[data-v-09ae31f4]{background:#e2f1f8;display:flex;align-items:center;justify-content:space-between;padding:1.6rem 2.4rem;margin-bottom:2.4rem;border-radius:16px;cursor:pointer}.answer-card>div[data-v-09ae31f4]{display:flex;flex-direction:column}.answer-card__title[data-v-09ae31f4]{font-weight:500;font-size:1.8rem;line-height:25px;color:#096390}.answer-card__sub-title[data-v-09ae31f4]{font-weight:500;font-size:1.4rem;line-height:18px;color:#7c858e}", ""]);
// Exports
module.exports = exports;
